/**
 * CRM chat file helpers. Image compression delegates to shared ≤100KB util.
 */
export {
  compressImageForUpload as compressImageForChat,
  isImageUploadFile as isImageChatFile,
  UPLOAD_IMAGE_MAX_BYTES as CRM_CHAT_IMAGE_MAX_BYTES,
  formatUploadFileSize as formatFileSize,
  prepareFileForUpload,
} from './imageUploadCompress';

export const CRM_CHAT_ALLOWED_EXTENSIONS = [
  'png', 'jpg', 'jpeg', 'webp',
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt',
  'zip', 'rar',
];

export function isAllowedChatFile(file) {
  if (!file?.name) return false;
  const ext = file.name.split('.').pop()?.toLowerCase();
  return ext && CRM_CHAT_ALLOWED_EXTENSIONS.includes(ext);
}
